import { createContext, PropsWithChildren, useState } from 'react'
import { IntlProvider } from 'react-intl'

import { LANGUAGE_KEY } from 'app/consts'
import getTranslationByLocale from 'app/utils/locales/getTranslationByLocale'

interface LocalizationContextType {
  locale: string
  selectLanguage: (lang: string) => void
}

const initialLocalizationContext: LocalizationContextType = {
  locale: '',
  selectLanguage: () => {},
}

export const LocalizationContext = createContext<LocalizationContextType>(
  initialLocalizationContext
)

const currentAppLanguage = localStorage.getItem(LANGUAGE_KEY)

const local = currentAppLanguage || navigator.language

let lang = getTranslationByLocale(local)

function LocalizationWrapper(props: PropsWithChildren<{}>) {
  const [locale, setLocale] = useState(local)
  const [messages, setMessages] = useState(lang)

  const selectLanguage = (lang: string) => {
    setLocale(lang)
    setMessages(getTranslationByLocale(lang))
    localStorage.setItem(LANGUAGE_KEY, lang)
  }

  return (
    <LocalizationContext.Provider value={{ locale, selectLanguage }}>
      <IntlProvider messages={messages} locale={locale}>
        {props.children}
      </IntlProvider>
    </LocalizationContext.Provider>
  )
}

export default LocalizationWrapper
